export const SHOW_MODAL = 'email_connect_exchange_modal: show';
export const HIDE_MODAL = 'email_connect_exchange_modal: hide';
export const RESET_MODAL_STATE = 'email_connect_exchange_modal: reset state';
